import React, { useCallback, useRef } from 'react';
import { QButton, QCloseButton, QModal, QModalActions, QModalBody, QModalHeader, QText } from '@qualio/ui-components';
import RichTextInput from '../../RichTextInput/RichTextInput';
import * as DisplayStrings from '../../../displayStrings';
import { Editor } from 'ckeditor5';

type DefaultContentModalProps = {
  setIfShow: React.Dispatch<React.SetStateAction<boolean>>;
  description: string | null;
  changeDefaultContent: any;
};

const DefaultContentModal = ({ setIfShow, description, changeDefaultContent }: DefaultContentModalProps) => {
  const editorRef = useRef<Editor | null>(null);

  const saveButtonText = description ? DisplayStrings.SaveChanges : DisplayStrings.AddDefaultContent;
  const header = description ? DisplayStrings.EditDefaultContent : DisplayStrings.AddDefaultContent;

  const close = () => {
    setIfShow(false);
  };

  const changeHelpTextClick = useCallback(() => {
    const currentContent = editorRef.current?.getData() ?? '';
    changeDefaultContent(currentContent);
    setIfShow(false);
  }, [changeDefaultContent, setIfShow]);

  return (
    <QModal isOpen={true} onClose={close} size="3xl" trapFocus={false} autoFocus={false}>
      <QModalHeader>
        <QText>{header}</QText>
        <QCloseButton onClick={close}></QCloseButton>
      </QModalHeader>
      <QModalBody>
        <RichTextInput
          value={description}
          onChange={() => undefined}
          onEditorReady={(editor) => {
            editorRef.current = editor;
          }}
        />
      </QModalBody>
      <QModalActions>
        <QButton data-cy={'cancel-save-description'} onClick={close} variant="outline">
          {DisplayStrings.Cancel}
        </QButton>
        <QButton data-cy={'save-description'} onClick={changeHelpTextClick}>
          {saveButtonText}
        </QButton>
      </QModalActions>
    </QModal>
  );
};

export default DefaultContentModal;
